import React, { createContext, useContext, useState, useEffect } from "react";

// Création du contexte
const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  const [cartCount, setCartCount] = useState(() => {
    const savedCartCount = localStorage.getItem("cartCount");
    return savedCartCount ? parseInt(savedCartCount, 10) : 0;
  });

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));

    // Calculer le nombre total d'articles
    const totalItems = cart.reduce((acc, item) => acc + item.quantity, 0);


    // Mettre à jour cartCount
    setCartCount(totalItems);

    
    // Sauvegarde du nombre d'articles dans localStorage
    localStorage.setItem("cartCount", totalItems.toString());
  }, [cart]);

  return (
    <CartContext.Provider value={{ cart, setCart, cartCount, setCartCount }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);